const EmptyWhiteCircle = (props: any) => (
	<svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx={12.0225} cy={12} r={11.5} fill="white" stroke="#437CA6" />
	</svg>
);
export default EmptyWhiteCircle;
